import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import MediaTypography from 'components/MediaTypography';
import { Formik } from 'formik';
import GoalFormToDoList from 'modules/Report/components/GoalFormToDoList';
import store from 'store';

import { postGoal } from '@common/api/goals';
import { postSteps } from '@common/api/goalsSteps';
import GoalsImageSrc from '@common/assets/images/about-me/goals/goals_lg.jpg';
import useModel from '@common/helpers/useModel';
import MainGoalModel, { IMainGoalModel } from '@common/models/Goals/MainGoal';

import {
	StyledGoalsCreateButton,
	StyledGoalsCreateStepsImg,
	StyledGoalsCreateStepsPaper,
} from '../styled';
import { StyledStepsCreateStep2Form, StyledStepsCreateStep2FormItems } from './styled';

interface PropsType {
	onClick: () => void;
	title: string;
}

function StepsCreateStep2({ onClick, title }: PropsType) {
	const mainGoalModel: IMainGoalModel = useModel(MainGoalModel, {}, [], { disableFetch: true });

	const handleSubmit = async (data: any) => {
		try {
			const result = await postGoal({
				main_goal_id: mainGoalModel?.id,
				title,
			});
			postSteps({
				steps: [
					...data.steps.map((step: any) => ({
						goal_id: result.id,
						title: step.title,
					})),
				],
			});
			onClick();
		} catch (e) {
			console.info(e);
		}
	};

	useEffect(() => {
		const getMainGoal = async () => {
			await mainGoalModel.fetch();
		};

		getMainGoal();
	}, []);

	return (
		<Formik onSubmit={handleSubmit} initialValues={{ steps: [] }}>
			{({ values }) => (
				<StyledStepsCreateStep2Form>
					<>
						<StyledGoalsCreateStepsPaper>
							<StyledGoalsCreateStepsImg alt="create goal step 2" src={GoalsImageSrc} />
							<StyledStepsCreateStep2FormItems>
								<MediaTypography
									variant="h3"
									variants={{ sm: 'h4' }}
									textColor="secondary"
									sx={{ textAlign: 'center' }}
								>
									Specify the main stages that will help to achieve the goal of “{title}”
								</MediaTypography>
								<GoalFormToDoList name="steps" />
							</StyledStepsCreateStep2FormItems>
						</StyledGoalsCreateStepsPaper>
						<StyledGoalsCreateButton
							type="submit"
							variant="contained"
							disabled={values.steps.length < 1 || !store.isSelfStudentView}
						>
							Complete
						</StyledGoalsCreateButton>
					</>
				</StyledStepsCreateStep2Form>
			)}
		</Formik>
	);
}

export default observer(StepsCreateStep2);
